var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 78,
    viewBox: "0 0 76 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7907 77.9816C43.7124 77.9816 43.6373 77.9798 43.5556 77.9762C41.7442 77.8762 40.1917 76.6481 39.6829 74.9047L31.9448 48.4767L3.68352 42.876C1.89825 42.5216 0.532721 41.0774 0.276834 39.2773C0.0221336 37.4777 0.930207 35.7103 2.54776 34.8743L63.3144 6.02064C67.9247 3.8315 72.8573 8.36389 71.0652 13.1426L47.7392 75.3417C47.0742 76.9497 45.5125 77.9816 43.7907 77.9816Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute2);
export default __webpack_public_path__ + "static/media/route 2.2234d543be9b7919732bd3b0b1aba766.svg";
export { ForwardRef as ReactComponent };